import { CheckIcon, MinusIcon } from '@phosphor-icons/react'
import * as CheckboxRadix from '@radix-ui/react-checkbox'
import { match } from 'ts-pattern'
import z from 'zod'
import * as styles from './checkbox.css.ts'

export const CheckboxStateSchema = z.enum(['default', 'disabled'])
export type CheckboxState = z.infer<typeof CheckboxStateSchema>

type CheckboxIconType = 'check' | 'dash'

type CheckboxProps = {
  state?: CheckboxState
  icon?: CheckboxIconType
  checked?: boolean
  Indicator?: React.ElementType
  onCheckedChange?: (checked: boolean) => unknown
  id?: string
  ariaLabel?: string
  /** Points at the element that says why the box is unavailable, for a disabled checkbox with a reason. */
  'aria-describedby'?: string
}

export const Checkbox = ({
  state = 'default',
  icon = 'check',
  checked,
  Indicator,
  onCheckedChange,
  id,
  ariaLabel,
  ...props
}: CheckboxProps) => (
  <CheckboxRadix.Root
    className={styles.checkboxRoot[state]}
    checked={checked}
    onCheckedChange={onCheckedChange}
    disabled={state === 'disabled'}
    onMouseDown={e => {
      e.preventDefault()
    }}
    asChild={true}
    {...props}
    aria-label={ariaLabel}
  >
    <button id={id}>
      {Indicator ? (
        <Indicator className={styles.checkboxIndicator}>{<Icon type={icon} />}</Indicator>
      ) : (
        <CheckboxRadix.Indicator className={styles.checkboxIndicator}>{<Icon type={icon} />}</CheckboxRadix.Indicator>
      )}
    </button>
  </CheckboxRadix.Root>
)

const Icon = ({ type }: { type: CheckboxIconType }) =>
  match(type)
    .with('check', () => <CheckIcon className={styles.checkboxIcon} size={16} weight="regular" />)
    .with('dash', () => <MinusIcon className={styles.checkboxIcon} size={16} weight="regular" />)
    .exhaustive()
